
import { ImageRecord } from "types";
import { useRef, useState } from "react";

const _record: ImageRecord = {};

export const useImages = () => {
  const [loaded, setLoaded] = useState(false);
  const preloadingRef = useRef(false);

  const getKey = (s: string) => {
    return s.toString().split("/").slice(-1)[0];
  };

  const getImages = () => {
    const images = require.context("assets/images", false, /^.*(\.jpg|\.png|\.svg)$/);
    return images.keys().map(image => images(image));
  };

  const setArrayBuffer = async(s: string) => {
    const key = getKey(s);
    await fetch(s)
      .then((response) => response.arrayBuffer())
      .then((arrayBuffer) => {
        _record[key] = arrayBuffer;
      });
  };

  const getArrayBuffer = (s: string) => {
    const key = getKey(s);
    return _record[key];
  };

  const loadImages = (images: string[]) => {
    return images.map(image => {
      return new Promise((resolve, reject) => {
        const key = getKey(image);
        if (!_record[key]) {
          const img = new Image();
          img.onload = () => {
            setArrayBuffer(image);
            resolve(_record[key]);
          };
          img.onerror = () => reject(Error("Network Error"));
          img.src = image;
        }else{
          resolve(_record[key]);
        }
      });
    });
  };

  const getApngs = () => {
    const images = require.context("assets/images/apng", false, /^.*(\.png)$/);
    return images.keys().map(image => images(image));
  };

  const preloadPublicImages = () => {
    const images = ['images/acr/logo.png'];
    Promise.allSettled(loadImages(images)).then((results) => {
      if(results.some(value => value.status === 'rejected')){
        setTimeout(preloadPublicImages, 1000);
      }else{
        setLoaded(true);
      }
    });
  };

  const preload = async () => {
    if(preloadingRef.current) return;
    preloadingRef.current = true;
    const images = getImages();
    for (const image of images) {
      const key = getKey(image);
      if (!_record[key]) {
        await setArrayBuffer(image);
      }
    }
    preloadPublicImages();
  };

  const preloadApngs = () => {
    const images = getApngs();
    for (const image of images) {
      const key = getKey(image);
      if (!_record[key]) {
        setArrayBuffer(image);
      }
    }
  };

  return {
    loaded,
    preload,
    getArrayBuffer,
    preloadApngs,
    loadImages,
  };
};
